<template>
    <div class="form-opt-bar-wrapper">
        <RoundButton :text="btnValue" @btnClick="btnClick"></RoundButton>
        <LangSelect :value="initLang" class="lang-select" @change="langSelect" :requireAll="true"></LangSelect>
        <Select :initValue="initStatus" :options="statusOptions" @menuClick="statusSelect" />
        <Select :initValue="initFormType" :options="formTypeOptions" @menuClick="formTypeSelect" />
        <Search :placeholder="formHolder" class="form-search" @searchChange="formSearch" @inputChange="formSearch"></Search>
    </div>
</template>

<script>
import RoundButton from "@/views/zhiji/bComponents/buttons/RoundButton";
import LangSelect from "@/components/langSelect";
import Select from "@/views/zhiji/bComponents/inputs/Select";
import Search from "@/views/zhiji/bComponents/inputs/Search";
import FormEditModal from "@/views/zhiji/components/formEdit/FormEditModal";
import { statusOptions, formTypeOptions } from "../formConfig.js";

export default {
    name: "FormOptBar",
    components: {
        RoundButton,
        Select,
        Search,
        LangSelect
    },
    computed: {
        initFormType() {
            return this.getStorePorp("querySetting").type || "all";
        },
        initLang() {
            return this.getStorePorp("querySetting").lang || "all";
        },
        initStatus() {
            return this.getStorePorp("querySetting").status || "all";
        },
        statusOptions() {
            return statusOptions();
        },
        formTypeOptions() {
            return formTypeOptions();
        },
        btnValue() {
            return this.$t("zhiji.form.addForm");
        },
        formHolder() {
            return this.$t("zhiji.common.inputHolderLabel");
        }
    },
    methods: {
        btnClick() {
            this.$store.dispatch("zhiji/showModal", {
                type: FormEditModal,
                data: {}
            });

            this.$store.dispatch("zhiji/initFormEditor", {});
            this.$store.commit("zhiji/updateCreateState", {
                isFirstCreate: true
            });
        },
        langSelect(data) {
            this.$emit("langSelect", {
                value: data
            });
        },
        statusSelect(data) {
            this.$emit("statusSelect", data);
        },
        formTypeSelect(data) {
            this.$emit("formTypeSelect", data);
        },
        formSearch(data) {
            this.$emit("formSearch", data);
        },
        getStorePorp(propName) {
            return this.$store.state.zhiji.formManagePage[propName];
        }
    }
};
</script>

<style lang="less" scoped>
.form-opt-bar-wrapper {
    display: flex;
    align-items: center;

    .form-search {
        width: 280px;
        padding: 7px 0;
    }

    .lang-select {
        width: 120px;
        margin-right: 8px;
    }
}
</style>
